var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.58286 2.08286C2.48912 1.17661 3.71826 0.66748 4.9999 0.66748C6.28153 0.66748 7.51067 1.17661 8.41693 2.08286C9.32318 2.98912 9.83231 4.21826 9.83231 5.4999C9.83231 6.78153 9.32318 8.01067 8.41693 8.91693C7.51067 9.82318 6.28153 10.3323 4.9999 10.3323C3.71826 10.3323 2.48912 9.82318 1.58286 8.91693C0.676609 8.01067 0.16748 6.78153 0.16748 5.4999C0.16748 4.21826 0.676609 2.98912 1.58286 2.08286ZM4.9999 1.66748C3.98348 1.66748 3.00869 2.07125 2.28997 2.78997C1.57125 3.50869 1.16748 4.48348 1.16748 5.4999C1.16748 6.51631 1.57125 7.4911 2.28997 8.20982C3.00869 8.92854 3.98348 9.33231 4.9999 9.33231C6.01631 9.33231 6.9911 8.92854 7.70982 8.20982C8.42854 7.4911 8.83231 6.51631 8.83231 5.4999C8.83231 4.48348 8.42854 3.50869 7.70982 2.78997C6.9911 2.07125 6.01631 1.66748 4.9999 1.66748ZM4.9999 4.99992C5.27604 4.99992 5.4999 5.22377 5.4999 5.49992V7.66612C5.4999 7.94226 5.27604 8.16612 4.9999 8.16612C4.72375 8.16612 4.4999 7.94226 4.4999 7.66612V5.49992C4.4999 5.22377 4.72375 4.99992 4.9999 4.99992ZM4.69594 3.11422C4.8038 3.04216 4.9306 3.00369 5.06032 3.00369C5.23426 3.00369 5.40108 3.07279 5.52408 3.19579C5.64708 3.31879 5.71618 3.48561 5.71618 3.65955C5.71618 3.78927 5.67772 3.91607 5.60565 4.02393C5.53358 4.13179 5.43115 4.21585 5.31131 4.26549C5.19146 4.31513 5.05959 4.32812 4.93237 4.30281C4.80515 4.27751 4.68828 4.21505 4.59655 4.12332C4.50483 4.03159 4.44237 3.91473 4.41706 3.78751C4.39175 3.66028 4.40474 3.52841 4.45438 3.40857C4.50402 3.28873 4.58808 3.18629 4.69594 3.11422Z",
          fill: "#676879",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }